(function() {
  'use strict';
  angular.module('cbl.telepass.wa.directives').directive('tlpsSpinnerDrct', [
    'TLPS_CONSTANTS',
    function(CONSTANTS) {
      var link = function(scope, elem, attrs, model) {};

      var controller = function($scope) {
        this.getSpinnerUrl = function() {
          var url = null;
          var currentScope = $scope;
          do {
            url = currentScope.srcSpinner;
            currentScope = currentScope.$parent;
          } while (url === undefined && currentScope !== null);
          return url;
          // return 'http://filiale-etica.preproduzione.cabel.net/CBL-BRIO-WA/common/assets/css/style/etica/img/ring-alt.gif';
        };
      };

      controller.$inject = ['$scope'];
      return {
        restrict: 'E',
        scope: {},
        templateUrl:
          CONSTANTS.BASE_ROOT + 'widgets/tlpsSpinner/tlpsSpinner.html',
        controller: controller,
        controllerAs: 'spinner',
        link: link
      };
    }
  ]);
})();



//////////////////
// WEBPACK FOOTER
// ./app/widgets/tlpsSpinner/tlpsSpinnerDrct.js
// module id = 39
// module chunks = 0